import React, { Component } from 'react';
import { isEmpty } from '../../Common/Common';

export default class Display_ACSummary_Cell extends Component {
	constructor(props) {
		super(props);

		this.state = {}
	}

	render() {
		let img_width = this.props.cell_width / 3;
		let font_size = (0.03) * this.props.cell_width;
		let table_width = this.props.cell_width - 20;
		let table_max_height = this.props.cell_height - 20;

		let table_style = {
			borderLeft: '2px solid rgb(139 139 139)',
			borderTop: '2px solid rgb(139 139 139)',
			width: table_width,
			maxHeight: table_max_height,
			overflow: 'auto',
			fontSize: font_size,
		}

		let col_style = {
			display: 'inline-block',
			width: (table_width / 5) - 2,
			borderRight: '2px solid rgb(139 139 139)',
			borderBottom: '2px solid rgb(139 139 139)',
			display: 'table-cell',
		}

		return (
			<div style={table_style}>
				<div style={{}}>
					<div style={col_style}>
						<span>{this.props.receiver.getString('name')} </span>
					</div>
					<div style={col_style}>
						<span>{this.props.receiver.getString('sp')} </span>
					</div>
					<div style={col_style}>
						<span>{this.props.receiver.getString('rt')} </span>
					</div>
					<div style={col_style}>
						<span>{this.props.receiver.getString('mode')} </span>
					</div>
					<div style={col_style}>
						<span>{this.props.receiver.getString('stat')} </span>
					</div>
				</div>
				{this.props.display_Ac_points.map((point_id) => {
					let point_info = window.app.state.point_list[point_id];
					return (
						<div style={{}}>
							<div style={col_style}>
								<span>{point_info.name} </span>
							</div>
							<div style={col_style}>
								<span>{point_info.actual_mode == 'C' ? point_info.csp : point_info.hsp} </span>
							</div>
							<div style={col_style}>
								<span>{point_info.temp} </span>
							</div>
							<div style={col_style}>
								<span>{point_info.mode} </span>
							</div>
							<div style={col_style}>
								<span>{point_info.stat} </span>
							</div>
						</div>
					)
				})}
			</div>
		)
	}
}